import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { CandidatesAddressType } from './candidates-address-type.interface';
import { CandidatesAddressTypeService } from './candidates-address-type.service';
const service = new CandidatesAddressTypeService();

export interface CandidatesAddressTypeState {
   candidatesAddressTypes: Array<CandidatesAddressType>;
}

const CandidatesAddressTypeStore: Module<CandidatesAddressTypeState, StoreState> = {
   namespaced: true,
   state: { candidatesAddressTypes: [] },
   getters: {
      candidatesAddressTypes: (state) => state.candidatesAddressTypes,
   },
   mutations: {
      SET_CANDIDATES_ADDRESS_TYPES(state, candidatesAddressTypes: Array<CandidatesAddressType>) {
         state.candidatesAddressTypes = candidatesAddressTypes;
      },
   },
   actions: {
      async getCandidatesAddressTypes(context) {
         const response = await service.getCandidatesAddressTypes();
         context.commit('SET_CANDIDATES_ADDRESS_TYPES', response.data);
         return response;
      },
   },
};

export default CandidatesAddressTypeStore;
